<template>
  <v-app id="app">
    <router-view :navigateTo="(x)=>navigateTo(x)"/>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {

    }
  },
  methods: {
    navigateTo(x) {
      this.$router.push({name:x})
    }
  },
}
</script>

<style>
#app {
}
.card--flex-toolbar {
  margin-top: -64px;
}

.bg-color {
  background: #4db6ac !important;
}
.bg-color-error {
  background: #c95b3d !important;
  background: linear-gradient(to left, #c95b3d, #ed2f06) !important;
}
</style>
